module.exports = __webpack_public_path__ + "static/img/bubble-inverse.0baa2a5.png";